module.exports = __webpack_public_path__ + "static/media/grad4.3cc5cde0.jpg";